// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { Button, buttonSizes } from 'moods-react/Button';
import InfiniteScroll from 'react-infinite-scroll-component';
import Approval from '../approval/ApprovalComponent';
import SkeletonTiles from '../../common/skeleton-tiles/SkeletonTilesComponent';
import type { Approval as ApprovalType } from '../../../api/types/Approvals';
import approvalMessages from '../../../data/approvals';

import './ApprovalList.scss';
import { APPROVAL_STATUS } from '../../../api/types/Approvals';

type Props = {
  total: number,
  items: Array<ApprovalType>,
  config: Object,
  isLoading: boolean,
  actions: Object,
};

type Context = {
  intl: Object,
};

function ApprovalsListComponent({ actions, total, items, isLoading }: Props, { intl }: Context) {
  const loadingPlaceholder = (
    <SkeletonTiles amount={3} fullWidth>
      <div className="approvals-list-component__skeleton-buttons">
        <Button
          size={buttonSizes.MEDIUM}
          isDisabled
          data-approval-decline-button
          className="approval-component__decline-button"
        >
          {intl.formatMessage(approvalMessages.approvalsDashboardDeclineButtonText)}
        </Button>
        <Button
          size={buttonSizes.MEDIUM}
          isDisabled
          data-approval-approve-button
          className="approval-component__approve-button"
        >
          {intl.formatMessage(approvalMessages.approvalsDashboardApproveButtonText)}
        </Button>
      </div>
    </SkeletonTiles>
  );

  if (isLoading && items.length === 0) {
    return <div className="approvals-list-component">{isLoading && loadingPlaceholder}</div>;
  }

  const numberOfVisibleItems = items.reduce((count: number, item: ApprovalType) => {
    return item.isHidden ? count : count + 1;
  }, 0);

  return (
    <div className="approvals-list-component">
      <InfiniteScroll
        dataLength={items.length}
        hasMore={total > numberOfVisibleItems}
        next={() => actions.getApprovals({ status: APPROVAL_STATUS.pending, fromItem: numberOfVisibleItems })}
        loader={loadingPlaceholder}
      >
        {items.map((item) => (
          <Approval
            key={`approval-list-item-${item.id}`}
            approval={item}
            updateApprovalStatus={actions.updateApprovalStatus}
            closeOverlay={actions.closeOverlay}
            showOverlay={actions.showOverlay}
          />
        ))}
      </InfiniteScroll>
    </div>
  );
}

ApprovalsListComponent.contextTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
};

export default ApprovalsListComponent;
